import Notification from './Notification';
export default Notification;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-notification/es/index.js
// module id = 350
// module chunks = 0